export default () => ({
  cartModal: false,
  loginModal: false,
  registerModal: false,
  resetPasswordModal: false,
  user: {},
  orders: [],
});
